import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  FormControlLabel,
  Checkbox,
} from "@mui/material";

const AddSampleBottleDialog = ({
  open,
  onClose,
  onAdd,
  onEdit,
  selectedItemToEdit,
}) => {
  const [sampleBottleName, setSampleBottleName] = useState("");
  const [description, setDescription] = useState("");
  const [invQuantity, setInvQuantity] = useState("");
  const [isActive, setIsActive] = useState(true);

  useEffect(() => {
    if (selectedItemToEdit) {
      setSampleBottleName(selectedItemToEdit.sampleBottleName || "");
      setDescription(selectedItemToEdit.description || "");
      setInvQuantity(selectedItemToEdit.invQuantity || 0);
      setIsActive(selectedItemToEdit.isActive !== false);
    }
  }, [selectedItemToEdit]);

  const handleAddClick = () => {
    const updatedItem = {
      ...selectedItemToEdit,
      sampleBottleName,
      description,
      isActive,
      invQuantity:invQuantity==="" ? 0 :parseInt(invQuantity),
    };
    if (selectedItemToEdit) {
      
      onEdit(updatedItem);
    } else {
      onAdd(updatedItem);
    }

    
  };

  const handleClose = () => {
    setSampleBottleName("");
    setDescription("");
    setInvQuantity("");
    setIsActive(true);
    onClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>
        {selectedItemToEdit ? "Edit Sample Bottle" : "Add New Sample Bottle"}
      </DialogTitle>
      <DialogContent>
        <TextField
          label="Sample Bottle Name"
          value={sampleBottleName}
          onChange={(e) => setSampleBottleName(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          fullWidth
          margin="normal"
        />
        <TextField
          label="Inventory Quantity"
          type="number"
          value={invQuantity}
          onChange={(e) => setInvQuantity(e.target.value)}
          fullWidth
          margin="normal"
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={isActive}
              onChange={(e) => setIsActive(e.target.checked)}
            />
          }
          label="Active"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>Cancel</Button>
        <Button onClick={handleAddClick} variant="contained" color="primary">
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AddSampleBottleDialog;
